import { render, staticRenderFns } from "./ServiceChange.vue?vue&type=template&id=4db12356&scoped=true"
import script from "./ServiceChange.vue?vue&type=script&lang=js"
export * from "./ServiceChange.vue?vue&type=script&lang=js"
import style0 from "./ServiceChange.vue?vue&type=style&index=0&id=4db12356&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db12356",
  null
  
)

export default component.exports